//
//
//
//
//
//
//
//

import uniqueid from 'lodash.uniqueid'
import _ from 'underscore'
export default {
  name: 'd2-layout-header-aside-menu-item',
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => ({
      })
    }
  },
  mounted () {
    this.$bus.$on('menuDotShow', (d) => {
      if (d.menu && (d.menu.path === this.menu.path)) {
        if(d.count == 0) {
          this.menu.hideDot = true
        }else{
          this.menu.dotCount = d.count
          this.menu.hideDot = false
        }
      }
    })
  },
  data () {
    return {
      uniqueid: uniqueid('d2-menu-empty-')
    }
  },
  methods: {
    handleClick () {
      console.log('menu-item.handleClick', true)
      if (this.menu.handleClick) {
        this.menu.handleClick.call(this)
      }
    }
  }
 }
